<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items"/>
        <b-card>
          <span v-if="ccl_lists.length > 0"   class="badge badge-success">Total Search Data Found: {{ ccl_lists.length }}</span>
          <button v-if="ccl_lists.length > 0"  type="button" id="export-table" @click="onexport"  class="btn btn-success float-right" style="margin-bottom:5px">Download Excel</button>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped" id="titledExcel">
              <thead>
              <tr>
                <th>Sl</th>
                <th>CCL No.</th>
                <th>Mouza</th>
                <th>Plot</th>
                <th>Amount</th>
                <th>Cheque Date</th>
                <th>Total Land</th>
                <th>Total EP</th>
                <th>CCL Type</th>
                <th>Book/Sub Book No.</th>
                <th>La Case</th>
                <th>Upload File</th>
<!--                <th>Action</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-for="(ccl_list, index) in ccl_lists" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ ccl_list.ccl_no }}</td>
                <td>{{ ccl_list.mouza ? ccl_list.mouza.mouza_desc : ''}} </td>
                <td>{{ ccl_list.plot ? ccl_list.plot.plot_no : '' }}</td>
                <td>{{ ccl_list.amount }}</td>
                <td>{{ ccl_list.cheque_date }}</td>
                <td>{{ ccl_list.total_land }}</td>
                <td>{{ ccl_list.number_of_eps }}</td>
                <td>{{ ccl_list.ccl_type ? ccl_list.ccl_type.ccl_type_desc : ''}}  </td>
                <td>{{ ccl_list.book_no }} <span v-if="ccl_list.book_sub_no">&nbsp / &nbsp {{ ccl_list.book_sub_no }}</span></td>
                <td>{{ ccl_list.la_case ? ccl_list.la_case.la_case_desc  : ''}}</td>
                <td>
                  <a v-if="ccl_list.extension == 'jpg' || ccl_list.extension == 'jpeg' || ccl_list.extension == 'png'" :href="ccl_list.document" target="_blank" download>
                    <img :src="ccl_list.document" alt="" class="rounded-circle" width="40" height="40" />
                  </a>

                  <a v-if="ccl_list.extension == 'pdf'" :href="ccl_list.document" target="_blank" download>
                    <img src="@assets/images/pdf.png" alt="" class="rounded-circle" width="40" height="40"/>
                  </a>
                  <a v-if="ccl_list.extension == 'docx' || ccl_list.extension == 'doc'" :href="ccl_list.document" target="_blank" download>
                    <img src="@assets/images/docx.png" alt="" class="rounded-circle" width="40" height="40"/>
                  </a>
                </td>
<!--                <td>-->
<!--                  <a href="javascript:void(0);"-->
<!--                     class="action-icon" title="View CCL" @click="viewCcl(ccl_list)">-->
<!--                    <i class="mdi mdi-account-card-details viewColor"></i>-->
<!--                  </a>-->
<!--                </td>-->
              </tr>
              </tbody>
            </table>
<!--            <div v-if="loader" class="loader">Loading...</div>-->
            <h5 class="text-center text-secondary" v-if="ccl_lists.total === 0 || !flag">
              No Data Found
            </h5>
<!--            <div class="float-right mt-1">
              <pagination :data="ccl_lists" :limit="2" @pagination-change-page="getResults"></pagination>
            </div>-->
          </div>
        </b-card>
      </div>
    </div>
    <view-modal
        :ccl_list="ccl_list"
    ></view-modal>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config.json";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import XLSX from 'xlsx';
import viewModal from './modal/viewModal'

export default {
  page: {
    title: "List of CCL Mouza",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, viewModal},
  data() {
    return {
      title: "List of CCL Mouza",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "List of CCL Mouza",
          active: true
        }
      ],
      mouza_id: '',
      mouzas: [],
      plots: [],
      land_types: [],
      ccl_types: [],
      ccl_lists: {},
      flag: false,
      ccl_list: {},
    };
  },

  mounted() {
    this.mouza_id = this.$route.params.mouza_id;
    this.mouzaSingleData(this.mouza_id);
  },
  methods: {
    mouzaSingleData(mouza_id) {
      http.get("api/ccl/get-mouza/" + mouza_id).then(response => {
        if (!response.error) {
          this.flag = true;
          this.ccl_lists = response.data.ccl_lists;
        }
      });
    },
    getResults(page = 1) {
      this.flag = true
      this.loader = true
      http.post('api/ccl/search?page=' + page, this.mouza_id)
          .then(response => {
            this.flag = true;
            this.loader = false
            this.ccl_lists = response.data.ccl_lists;
          });
    },
    onexport(evt) {
      var tbl = document.getElementById('titledExcel');
      var wb = XLSX.utils.table_to_book(tbl);
      XLSX.writeFile(wb, "ccl.xlsx");
    },
    viewCcl(ccl_list){
      this.ccl_list = {};
      this.ccl_list = ccl_list;
      this.$root.$emit("bv::show::modal", "ccl-view-page-modal");
    },
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    }
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
